export default __webpack_public_path__ + "static/media/fail-icon.0333512a.svg";